import {
    ApplicationConfig,
    importProvidersFrom,
    provideZoneChangeDetection,
    provideAppInitializer,
    isDevMode,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Noir from '@/themes/doktar-preset';
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { httpErrorHandlingInterceptor } from './core/interceptors/http-error-handling.interceptor';
import { customHttpInterceptor } from './core/interceptors/custom-http.interceptor';
import { MessageService } from 'primeng/api';
import { AuthService } from './auth/services/auth.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
    API_BASE_URL,
    AccessEnterpriseProxy,
    AccessRoleProxy,
    ConfigurationProxy,
    LookupProxy,
    UserProxy,
    NotificationProxy,
} from '@/app/proxy/proxies';
import { environment } from '@/environments/environment';
import { DialogService } from 'primeng/dynamicdialog';
import { AppConfigService } from './core/services/app-config.service';
import { AnalyticsService } from './core/services/analytics.service';
import { NotificationSignalrService } from './core/services/notification-signalr.service';
import { NotificationService } from './core/services/notification.service';
import { provideServiceWorker } from '@angular/service-worker';
import { ToastService } from './core/services/toast.service';
import { NoCacheInterceptor } from './core/interceptors/no-cache.interceptor';
import { TabRouteReuseStrategy } from './core/routing/tab-route-reuse.strategy';

export const HttpLoaderFactory = (http: HttpClient) => {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
};

export const provideTranslation = () => ({
    defaultLanguage: 'en',
    loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
    },
});

export const appConfig: ApplicationConfig = {
    providers: [
        ConfigurationProxy,
        provideAppInitializer(async () => {
            const appConfigService = inject(AppConfigService);
            const analyticsService = inject(AnalyticsService);

            try {
                await appConfigService.initializeApp();
                await analyticsService.getStatus();

                return true;
            } catch (error) {
                console.error('Error initializing app:', error);
                return false;
            } finally {
                console.log('App initialized');
            }
        }),
        provideRouter(routes),
        { provide: RouteReuseStrategy, useClass: TabRouteReuseStrategy },
        provideAnimations(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([customHttpInterceptor, httpErrorHandlingInterceptor, NoCacheInterceptor])
        ) /*
    { provide: Sentry.TraceService },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },*/,
        {
            provide: API_BASE_URL,
            useValue: environment.apiBaseUrl,
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: Noir,
        }),
        MessageService,
        ToastService,
        AuthService,
        UserProxy,
        NotificationProxy,
        AccessEnterpriseProxy,
        AccessRoleProxy,
        LookupProxy,
        DialogService,
        NotificationSignalrService,
        NotificationService,
        importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.enableServiceWorker,
            registrationStrategy: 'registerWhenStable:30000',
        }),
    ],
};
